import type { GoodsData } from '@banhala/ui-kit';
import type {
  GoodsCoreModel,
  GoodsRenderModel,
  IScreensLogging,
} from 'shared/src/api/types';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

type FolderGoodsItem = GoodsCoreModel & {
  render: GoodsRenderModel;
  logging: IScreensLogging;
};

export type FolderGoodsCardItem = GoodsData & FolderGoodsItem;

export const convertFolderGoodsItemToGoodsData = (
  goods: FolderGoodsItem,
): FolderGoodsCardItem => {
  const { render, logging, ...item } = goods;
  return {
    ...item,
    render,
    logging,
    ...convertRenderDataToGoodsData(
      { item, render },
      { thumbnailOverrides: { hideLike: true } },
    ),
  };
};
